import axios from "axios";
import { API } from "@/lib/api";

const VISITOR_KEY = "hq_visitor_id";
const SESSION_KEY = "hq_session_id";
const SESSION_TS_KEY = "hq_session_ts";
const EXCLUDE_KEY = "hq_analytics_excluded";
const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

const uuid = () => (crypto?.randomUUID ? crypto.randomUUID() : `v-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`);

function getVisitorId() {
  try {
    let v = localStorage.getItem(VISITOR_KEY);
    if (!v) { v = uuid(); localStorage.setItem(VISITOR_KEY, v); }
    return v;
  } catch { return "anon"; }
}

function getSessionId() {
  try {
    const now = Date.now();
    const last = parseInt(sessionStorage.getItem(SESSION_TS_KEY) || "0", 10);
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid || (last && now - last > SESSION_TIMEOUT_MS)) { sid = uuid(); sessionStorage.setItem(SESSION_KEY, sid); }
    sessionStorage.setItem(SESSION_TS_KEY, String(now));
    return sid;
  } catch { return "sess"; }
}

// Group dynamic ids: /studio/docs/docs-m3 -> /studio/docs/:mission, /assessment/docs-cp1 -> /assessment/:id
export function normalizePath(pathname) {
  const p = pathname || "/";
  return p
    .replace(/^\/studio\/([a-z]+)\/[^/]+$/, "/studio/$1/:mission")
    .replace(/^\/assessment\/[^/]+$/, "/assessment/:id")
    .replace(/^\/quest\/[^/]+$/, "/quest/:id")
    .replace(/^\/report\/[^/]+$/, "/report/:id")
    .slice(0, 256);
}

export const isAnalyticsExcluded = () => { try { return localStorage.getItem(EXCLUDE_KEY) === "1"; } catch { return false; } };
export const setAnalyticsExcluded = (v) => { try { v ? localStorage.setItem(EXCLUDE_KEY, "1") : localStorage.removeItem(EXCLUDE_KEY); } catch { /* ignore */ } };

let lastKey = null;

export async function trackPageView(pathname) {
  try {
    if (isAnalyticsExcluded()) return;
    const path = normalizePath(pathname);
    const sid = getSessionId();
    const key = `${sid}::${path}`;
    if (lastKey === key) return;
    lastKey = key;
    await axios.post(`${API}/analytics/pageview`, {
      visitor_id: getVisitorId(), session_id: sid, path, referrer: document.referrer || "", screen_width: window.innerWidth || 0,
    }, { withCredentials: true });
  } catch { /* tracking must never break the app */ }
}
